import { DiscoveryApi } from "@backstage/core-plugin-api";
import { LastDeployStatus, AmplifyBackendApi } from "../types";

export class AmplifyBackendClient implements AmplifyBackendApi {
  private readonly discoveryApi: DiscoveryApi;

  constructor(options: {discoveryApi: DiscoveryApi}) {
    this.discoveryApi = options.discoveryApi;
  }
  private async handleResponse(response: Response): Promise<any> {
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return await response.json();
  }

  async getLastDeployStatus(branchName: string, appId: string): Promise<LastDeployStatus> {
    const url = `${await this.discoveryApi.getBaseUrl('amplify-backend')}/${appId}/branches/${branchName}/last-deploy`;
    const response = await fetch(url, {
      method: 'GET',
    });
    console.log('test');
    return await this.handleResponse(response);
  }
}
